export default "__VITE_ASSET__C8bbSCxv__"